<form action="">
  <fieldset class="filter-gallery-model-block">
    <!-- Car Brand Autocomplete -->
    <mat-form-field appearance="outline">
      <input
        #input
        type="text"
        placeholder="ยี่ห้อรถยนต์"
        matInput
        [formControl]="carBrandControl"
        [matAutocomplete]="auto"
        (input)="filter()"
        (focus)="filter()"
      />
      <mat-autocomplete requireSelection #auto="matAutocomplete" (optionSelected)="onSelectCarOptionChange($event)">
        @for (option of filteredOptions() ; track option) {
        <mat-option [value]="option.name">{{ option.name }}</mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
    <!-- Car Model Autocomplete -->
    <mat-form-field appearance="outline">
      <input
        #inputModel
        type="text"
        placeholder="รุ่นรถยนต์"
        matInput
        [formControl]="carModelControl"
        [matAutocomplete]="modelCar"
        [disabled]="true"
        (input)="filterModel()"
        (focus)="filterModel()"
      />
      <mat-autocomplete #modelCar="matAutocomplete" (optionSelected)="onSelectModelOptionChange('car_model_id', $event)">
        @for (carModelOption of filteredOptionsModel(); track carModelOption.id) {
        <mat-option [value]="carModelOption.name">{{ carModelOption.name }}</mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
    <!-- tire Brand Autocomplete -->
    <!-- <mat-form-field appearance="outline"> -->
    <!-- <input
        #inputTireBrand
        type="text"
        placeholder="ยี่ห้อยาง"
        matInput
        [formControl]="tireBrandControl"
        [matAutocomplete]="tireBrand"
        (input)="filterTireBrand()"
        (focus)="filterTireBrand()"
      />
      <mat-autocomplete #tireBrand="matAutocomplete" (optionSelected)="onSelectCarOptionChange($event)">
        @for (tireBrandOption of filteredOptionsTireBrand(); track i; let i = $index) {
        <mat-option [value]="tireBrandOption.name">{{ tireBrandOption.name }}</mat-option>
        }
      </mat-autocomplete> -->
    <!-- <input #inputTireBrand type="text" placeholder="ยี่ห้อยาง" matInput [matAutocomplete]="tireBrand" />
      <mat-autocomplete #tireBrand="matAutocomplete">
        <mat-option>No Data</mat-option>
      </mat-autocomplete>
    </mat-form-field> -->
    <!-- Tire Model Autocomplete -->
    <mat-form-field appearance="outline">
      <input
        #inputTireModel
        type="text"
        placeholder="รุ่นยาง"
        matInput
        [formControl]="tireModelControl"
        [matAutocomplete]="tireModel"
        (input)="filterTireModel()"
        (focus)="filterTireModel()"
      />
      <mat-autocomplete
        #tireModel="matAutocomplete"
        requireSelection
        (optionSelected)="onSelectModelOptionChange('tire_model_name', $event)"
      >
        @for (tireModelOption of filteredOptionsTire(); track i; let i = $index) {
        <mat-option [value]="tireModelOption.name">{{ tireModelOption.name }}</mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>

    <!-- /////// -->

    <button matButton="filled" (click)="clearAllValues()" type="button">เคลียร์</button>
  </fieldset>
</form>
